import React, { useEffect, useState } from 'react';
import { Alert, Button, Col, Collapse, Divider, Form, Input, Popover, Row, Table, Tag, notification } from "antd";
import { PlusOutlined, MinusOutlined, PrinterOutlined, EditOutlined, ArrowDownOutlined, DeleteOutlined, ExclamationCircleOutlined, CloseCircleOutlined, ArrowUpOutlined, SearchOutlined, EyeOutlined } from '@ant-design/icons';

import { useStateValue } from '../../state';
import { drawerActions, listagemActions, manutencaoActions } from "../../actions";
import api from '../../services/api';
import { Adicionar, BreadcrumbIncluirDados, BreadcrumbPage, Excluir, Imprimir } from '../../components';
import { Modal } from 'antd';
import DrawerPlanoContabil from './drawer';
import { NotificationPlacements } from 'antd/es/notification/interface';
import { atualizarLista } from './drawer';
import ModalDetalhePlanoConta from '../../components/modals/modalDetalhePlanoConta';



export default function PlanoContaContabil({ }) {

    const [{ manutencao }, dispatch] = useStateValue();
    const [editando, setEditando] = useState(false);
    const [formPesquisa] = Form.useForm();
    const [listaPlanoContaContabil, setListaPlanoContaContabil] = useState([]);
    const [openDrawerPlanoContaContabil, setOpenDrawerPlanoContaContabil] = useState(false);
    const [form] = Form.useForm();
    const [DadosDetalhesPlanoContaContabil, setDadosDetalhesPlanoContaContabil] = useState(null);
    const [openModalDetalhePPC, setOpenModalDetalhePPC] = useState(false);
    const [planoContasOriginal, setPlanoContasOriginal] = useState([]);
    const [planoContasExibidas, setPlanoContasExibidas] = useState([]);


    const { Panel } = Collapse;

    useEffect(() => {
        // atualizarListaPrincipal();
        // dispatch({ type: listagemActions.CHANGE, data: { outrosFiltros: '', filtro: '', ordem: '+pcc_descricao' } });
        api.get('PlanoContaContabil/ListarTodos').then(res => {
            const hierarquia = montarHierarquia(res.data);
            setPlanoContasOriginal(hierarquia);
            setListaPlanoContaContabil(hierarquia);
        })
    }, []);

    function atualizarListaPrincipal() {
        api.get('PlanoContaContabil/ListarTodos').then(res => {
            const hierarquia = montarHierarquia(res.data);
            setListaPlanoContaContabil(hierarquia);
        });
    };

    const montarHierarquia = (lista) => {
        const mapa = new Map();
        const raiz = [];

        lista.forEach(item => {
            item.filhos = [];
            mapa.set(item.pcc_id, item);
        });

        lista.forEach(item => {
            if (item.pcc_pai) {
                const pai = mapa.get(item.pcc_pai);
                if (pai) pai.filhos.push(item);
                else raiz.push(item);
            } else {
                raiz.push(item);
            }
        })
        return raiz;
    }

    function excluirRegistro(dados) {
        if (!dados?.pcc_id) {
            notification.error({
                message: 'Erro ao excluir',
                description: 'ID da conta não foi encontrado.',
            });
            return;
        }
        Modal.confirm({
            title: 'Deseja realmente excluir esta conta?',
            icon: <ExclamationCircleOutlined />,
            okText: 'Sim',
            cancelText: 'Cancelar',
            onOk: async () => {
                try {
                    const res = await api.delete(`PlanoContaContabil/Excluir/${dados.pcc_id}`);
                    if (res.data === true) {
                        notification.success({
                            message: 'Sucesso',
                            description: 'Conta excluida com sucesso.',
                        });
                        atualizarListaPrincipal();
                    } else {
                        throw new Error(res.data?.mensagem || 'Erro inesperado');
                    }
                } catch (error) {
                    notification.error({
                        message: 'Erro ao excluir',
                        description: error?.response?.data || error.message || 'Erro inesperado.',
                    });
                }
            }
        });
    }

    async function visualizarDetalhes(plano) {
        try {
            let data = await api.get(`PlanoContaContabil/BuscarDetalhes/${plano.pcc_id}`);
            if (data.status === 200) {
                setDadosDetalhesPlanoContaContabil(data.data);
                setOpenModalDetalhePPC(true);
            }
        } catch (error) {
            notification.error({
                message: 'Erro ao carregar dados do veículo.',
                description: ' Não foi possível carregar os detalhes do veículo. Tente novamente.'
            });
        }
    }

    const filtrarConta = async (valorPesquisa) => {
        try {
            if(!valorPesquisa) {
                // atualizarListaPrincipal();
                setListaPlanoContaContabil(planoContasOriginal);
                return;
            }
            
            const response = await api.get("PlanoContaContabil/ListarTodos", {
                params: {
                    pcc_descricao: valorPesquisa,
                },
            });
            const hierarquia = montarHierarquia(response.data);
            setListaPlanoContaContabil(hierarquia);

        } catch (error) {
            console.error("Erro ao buscar dados:", error);
        }
    }


    const columns = [
        {
            title: 'Descrição',
            dataIndex: 'pcc_descricao',
            render: (texto) => (
                <span style={{marginLeft: 8}}>{texto}</span>
            ),
        },
        {
            title: 'Ações',
            key: 'acoes',
            render: (_, registro) => (
                <Row justify="end" gutter={[4, 0]}>
                    <Col>
                        <Button icon={<EditOutlined />} size="small" onClick={(e) => {
                            e.stopPropagation();
                            console.log("Registro clicado para editar:", registro);
                            dispatch({ type: manutencaoActions.CHANGE, data: { dados: registro } });
                            setOpenDrawerPlanoContaContabil(true);
                            setEditando(true);
                        }}
                        />
                    </Col>
                    <Col>
                        <Button
                            icon={<EyeOutlined />}
                            size="small"
                            onClick={(e) => { e.stopPropagation(); visualizarDetalhes(registro); }}
                        />
                    </Col>
                    <Col>
                        <Button icon={<DeleteOutlined />} size="small" onClick={(e) => { e.stopPropagation(); excluirRegistro(registro) }} />
                    </Col>
                </Row>
            ),
        },
    ];

    return (
        <div className="p-10">
            <Row align="middle" justify="space-between" gutter={[8, 0]} className="col-pagina-breadcrumb">
                <Col className="col-mob-100">
                    <BreadcrumbPage />
                </Col>
                <Col className="col-mob-100">
                    <Row align="middle" justify="end">
                        <Col>
                            <Button type="primary" icon={<PlusOutlined />} size="middle" onClick={() => setOpenDrawerPlanoContaContabil(true)}>NOVO</Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Form layout="vertical" form={formPesquisa} name="formPesquisa">
                <Row align="middle" gutter={[8, 8]}>
                    <Col span={24}>
                        <Form.Item label="pesquisar por" name="pesquisa">
                            <Input.Search defaultValue="" placeholder={"Código, descrição"} onSearch={valor => filtrarConta(valor)} allowClear />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
            <div className="colCollapseTabela">
                <Collapse expandIcon={({ isActive }) => isActive ? <MinusOutlined /> : <PlusOutlined />}>
                    {listaPlanoContaContabil.map(plano => (
                        <Collapse.Panel key={plano.pcc_id} header={plano.pcc_descricao} extra={
                            <Row align="middle" justify="space-between" style={{ width: '100%' }}>
                                <Col>
                                    <Row gutter={8}>
                                        <Col>
                                            <Button
                                                icon={<EditOutlined />}
                                                size="small"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    console.log("Registro clicado para editar:", plano);
                                                    dispatch({ type: manutencaoActions.CHANGE, data: { dados: plano } });
                                                    setOpenDrawerPlanoContaContabil(true);
                                                    setEditando(true);
                                                }}
                                            />
                                        </Col>
                                        <Col>
                                            <Button
                                                icon={<EyeOutlined />}
                                                size="small"
                                                onClick={(e) => { e.stopPropagation(); visualizarDetalhes(plano); }}
                                            />
                                        </Col>
                                        <Col>
                                            {!plano.filhos?.length && (
                                                <Button
                                                    icon={<DeleteOutlined />}
                                                    size="small"
                                                    onClick={(e) => { e.stopPropagation(); excluirRegistro({ ...plano, id: plano.pcc_id }) }}
                                                />
                                            )}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        }>
                            <Table
                                dataSource={plano.filhos || []}
                                rowKey="pcc_id"
                                columns={columns}
                                pagination={false}
                                expandable={{
                                    childrenColumnName: 'filhos',
                                    expandIcon: ({ expanded, onExpand, record }) =>
                                        expanded ? (
                                            <ArrowUpOutlined onClick={e => onExpand(record, e)} />
                                        ) : (
                                            <ArrowDownOutlined onClick={e => onExpand(record, e)} />
                                        )
                                }}
                            />
                            <Divider className="m-0" />
                            <Row align="middle" justify="center" className="p-10">
                                <Col>
                                    <Adicionar
                                        type="primary"
                                        icon={<PlusOutlined />}
                                        size="middle"
                                        onClick={(item) => {
                                          
                                            dispatch({ type: manutencaoActions.CHANGE, data: { dados: null, } });
                                            setOpenDrawerPlanoContaContabil(true);
                                        }}
                                    >
                                        Adicionar
                                    </Adicionar>
                                </Col>
                            </Row>
                        </Collapse.Panel>
                    ))}
                </Collapse>
            </div>
            <DrawerPlanoContabil editando={editando} setEditando={setEditando} openDrawer={openDrawerPlanoContaContabil} setOpenDrawer={setOpenDrawerPlanoContaContabil} atualizarLista={() => atualizarListaPrincipal} />
            <ModalDetalhePlanoConta exibirModal={openModalDetalhePPC} fecharModal={() => setOpenModalDetalhePPC(false)} dadosModal={DadosDetalhesPlanoContaContabil} />
        </div>
    );
}